// extracted by mini-css-extract-plugin
export default {"container":"wxw5MNvpYGoG5MS8gSnt","label":"U7MtiSwgkW4KeJasJPHS","contentWrapper":"w39Xv7QL5CiaJO84byMI","content":"doCjhxNVJKfw3Oi8Gp4i"};